import {createAction} from '@reduxjs/toolkit'

const action = 'search'

export const initSearch = createAction<{
    keyword?: string
    startDate?: string
    endDate?: string
    categories?: string[]
    details?: string[]
}>(`${action}/init`)

export const changeSearchKeywordAction = createAction<string>(`${action}/changeKeyword`)

export const resetSearchKeywordAction = createAction(`${action}/resetKeyword`)

export const changeSearchDateAction = createAction<{
    startDate: string
    endDate: string
}>(`${action}/changeDate`)

export const selectSearchCategoryAction = createAction<{
    code: string
}>(`${action}/selectCategory`)

export const unselectSearchCategoryAction = createAction<{
    code: string
}>(`${action}/unselectCategory`)

export const selectSearchDetailAction = createAction<{
    code: string
}>(`${action}/selectDetail`)

export const unselectSearchDetailAction = createAction<{
    code: string
}>(`${action}/unselectDetail`)
